<template>
  <b-card
    class="expertise-items"
    :class="isIdxOdd ? 'expertise-items-bg-white' : 'expertise-items-bg-white-1'"
    :body-class="`card-body  max-height-280 ${item.bg}`"
  >
    <b-card-body
      class="p-0 d-flex"
      :class="{'flex-row-reverse': isIdxOdd}"
    >
      <b-card-text
        class="card-ctx text-primary l-h-22 grey"
      >
        {{ item.shortContext }}
      </b-card-text>

      <b-card-title
        class="title text-primary font-weight-bold f-s-22 l-s-0"
        :class="isIdxOdd ? 'title-from-right' : 'title-from-left'"
      >
        {{ item.title }}
      </b-card-title>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'ExpertiseItems',
  props: {
    item: {
      type: Object,
      default: null,
    },
    idx: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isIdxOdd() {
      return !!(this.idx % 2);
    },
  },
};
</script>
